module.exports = __webpack_public_path__ + "static/img/si2.e8f2e74.png";


//////////////////
// WEBPACK FOOTER
// ./src/imges/si2.png
// module id = 8KcE
// module chunks = 0